module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-3ee2a05a.png";